export function useDownload() {
  return (url: string, filename?: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename ?? `download`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
}
